export default __webpack_public_path__ + "static/media/dashboard_clinical_operations_session_icon.86c6567f.svg";